import { HistoryEvent } from '../../../../../services/eventingApi';
import { deliveryLabel, formatDateTime, shortId } from '../shared/format';
import { Badge } from '../shared/ui';

interface EventRowProps {
  event: HistoryEvent;
  selected: boolean;
  onToggle: () => void;
  onOpen: () => void;
}

const EventRow = ({ event, selected, onToggle, onOpen }: EventRowProps) => {
  const { message, aggregate } = event;

  return (
    <tr className="cursor-pointer border-t border-gray-100 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-100 dark:hover:bg-slate-700" onClick={onOpen}>
      <td className="px-2 py-2" onClick={(click) => click.stopPropagation()}>
        <input type="checkbox" aria-label={`Selecionar ${message.eventId}`} checked={selected} onChange={onToggle} />
      </td>
      <td className="px-2 py-2">{formatDateTime(message.occurredAt)}</td>
      <td className="px-2 py-2 font-mono">{message.eventType}</td>
      <td className="px-2 py-2">
        <Badge label={deliveryLabel(message.delivery, message.deliveryFormatted)} />
      </td>
      <td className="px-2 py-2 font-mono">{shortId(aggregate.aggregateId)}</td>
      <td className="px-2 py-2">v{aggregate.aggregateVersion}</td>
      <td className="px-2 py-2 font-mono">{shortId(message.eventId)}</td>
    </tr>
  );
};

export default EventRow;
